import { render } from "./AboutTeam.vue?vue&type=template&id=fd54a71c&scoped=true"
import script from "./AboutTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTeam.vue?vue&type=script&setup=true&lang=js"

import "./AboutTeam.vue?vue&type=style&index=0&id=fd54a71c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd54a71c"],['__file',"resources/frontend/js/components/AboutTeam.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd54a71c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd54a71c', __exports__)) {
    api.reload('fd54a71c', __exports__)
  }
  
  module.hot.accept("./AboutTeam.vue?vue&type=template&id=fd54a71c&scoped=true", () => {
    api.rerender('fd54a71c', render)
  })

}


export default __exports__